export enum BRAND_ACTION_TYPES {
  FETCH_ALL_DATA = "brand/FETCH_ALL_DATA",
  UPDATE_BRAND = "brand/UPDATE_BRAND",
  SET_DATA = "brand/SET_DATA",
  SET_IS_LOADING = "brand/SET_IS_LOADING",
}
